
export default {
  name: "filterPills",
  data() {
    return {};
  },
  methods: {
    async removeFilter(ba, sfilter) {
      await this.$store.dispatch("syncSearch", { ba, sfilter });
      await this.$store.dispatch("doSearch");
      // await this.$store.dispatch("getAutoCompletes", { merge: true,properties:'manufacturer,tags' });
    },
  },
};
